// src/components/table/GlobalSearch.jsx
import React from 'react';
import {
  Paper,
  InputBase,
  IconButton,
} from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';

export default function GlobalSearch({
  value,
  onChange,
  placeholder = "Search...",
  width = 400,
  sx = {},
}) {
  return (
    <Paper
      component="form"
      sx={{
        p: '2px 4px',
        display: 'flex',
        alignItems: 'center',
        width,
        ...sx
      }}
    >
      <InputBase
        sx={{ ml: 1, flex: 1 }}
        placeholder={placeholder}
        value={value}
        onChange={onChange}
        inputProps={{ 'aria-label': 'search table' }}
        onKeyDown={(e) => e.key === 'Enter' && e.preventDefault()}
      />
      <IconButton type="button" sx={{ p: '10px' }} aria-label="search">
        <SearchIcon />
      </IconButton>
    </Paper>
  );
}